export default {
    registeredResidence: {
        other: { value: "7ef591e5-1c1c-484d-9ea7-7c5cc2ca8c4d" },
    },

    bank: {
        swedbank: { value: 1 },
        seb: { value: 2 },
        lhv: { value: 3 },
        coop: { value: 4 },
        luminor: { value: 5 },
        danske: { value: 6 }
    }
}


// WEBPACK FOOTER //
// ./www/js/enum.ts